




























































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Button,
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { InsuranceServices } from '../api/InsuranceServices';
import { harvestDepurationExport, HarvestRanchListFilters } from '../api/models';
import { PRIVILEGE_KEYS } from '../../../features/core/utils/privileges';

@Component({
    components: {
        Loading,
        Button,
    }
})
export default class ModalHarvestExportDepuration extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {

    @Prop() tableSearchParams: HarvestRanchListFilters;
    @Prop() ranchIds: string[];
    @Prop({default: false}) isCarrier: boolean;
    @Prop({default: false}) visible: boolean;
    loadingExport: boolean = false;
    headers:Array<object> = [
        { text: '', value: 'name', sortable: false },
        { text: 'PNG', value: 'png', sortable: false  },
        { text: 'SHP', value: 'shp', sortable: false  },
        { text: 'CSV', value: 'csv', sortable: false  },
        { text: 'GeoJSON', value: 'geojson', sortable: false  }
      ]

    items: Array<object> = [
        { name: 'Mapa de Rendimiento Local Full', png: false, shp: false, csv: false, geojson: false, key: 'csv_map_file', isCarrier: false, isCarrierLimited: false },
        { name: 'Mapa de Rendimiento Local', png: false, shp: false, csv: false, geojson: false, key: 'deliverable_csv_map_file', isCarrier: false, isCarrierLimited: false },
        { name: 'Mapa de Rendimiento Telemático Full', png: false, shp: false, csv: false, geojson: false, key: 'telemetry_csv', isCarrier: false, isCarrierLimited: false },
        { name: 'Mapa de Rendimiento Telemático', png: false, shp: false, csv: false, geojson: false, key: 'deliverable_telemetry_csv', isCarrier: false, isCarrierLimited: false },
        { name: 'Mapa de Rendimiento Completo Full', png: false, shp: false, csv: false, geojson: false, key: 'telemetry_and_csv', isCarrier: false, isCarrierLimited: false },
        { name: 'Mapa de Rendimiento Completo', png: false, shp: false, csv: false, geojson: false, key: 'deliverable_complete', isCarrier: true, isCarrierLimited: true },
        { name: 'Polígono de Chacra', png: false, shp: false, csv: false, geojson: false, key: 'ranch_polygon', isCarrier: true, isCarrierLimited: true },
        { name: 'Polígono de Avance', png: false, shp: false, csv: false, geojson: false, key: 'harvested_ranch_polygon', isCarrier: true, isCarrierLimited: true },
        { name: 'Imagen Satelital Representativa', png: false, shp: false, csv: false, geojson: false, key: 'most_representative_satellite_image', isCarrier: true, isCarrierLimited: true },
        { name: 'Imágenes Satelitales', png: false, shp: false, csv: false, geojson: false, key: 'ranch_satellite_image', isCarrier: true, isCarrierLimited: true },
    ]
    pngFields: Array<string> = ['most_representative_satellite_image', 'ranch_satellite_image', 'deliverable_complete'];
    shpFields: Array<string> = ['ranch_polygon', 'harvested_ranch_polygon', 'csv_map_file', 'deliverable_csv_map_file', 'telemetry_csv', 'telemetry_and_csv', 'deliverable_telemetry_csv', 'deliverable_complete'];
    csvFields: Array<string> = ['csv_map_file', 'deliverable_csv_map_file', 'telemetry_csv', 'telemetry_and_csv', 'deliverable_telemetry_csv', 'deliverable_complete'];
    geojsonFields: Array<string> = ['ranch_polygon', 'harvested_ranch_polygon']


    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    exportDepuration() {
        this.$_showLoadingDialog('Exportando depuración...');

        let filters = this.tableSearchParams;
        if(filters.companies){
            filters.companies = filters.companies.join(',');
        }
        if(filters.query === ''){
            delete filters['query']
        }
        let pngFieldsChecked = this.items.filter(item => item['png'] === true).map(item => item['key']);
        let shpFieldsChecked = this.items.filter(item => item['shp'] === true).map(item => item['key']);
        let csvFieldsChecked = this.items.filter(item => item['csv'] === true).map(item => item['key']);
        let geojsonFieldsChecked = this.items.filter(item => item['geojson'] === true).map(item => item['key']);
        

        let config:harvestDepurationExport = {
            png: pngFieldsChecked,
            shp: shpFieldsChecked,
            csv: csvFieldsChecked,
            geojson: geojsonFieldsChecked,
            harvest_ranch_ids: this.ranchIds
        }
        this.loadingExport = true;
        InsuranceServices.exportHarvestRanchsDepuration(
            config,
            filters
        ).then((res) => {
            this.$_successLoadingDialog({
                response: res,
                alternative_msg: 'Archivo generado con éxito',
                timeout: 12000
            });
        }).catch((error) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudo generar el archivo'
            });
        }).finally(() => {
            this.loadingExport = false;
        });
    }

   

    filterRowsToInsuranceCarrier(){
        let exportItems = this.items;
        if(this.isCarrier){
             exportItems = exportItems.filter(item => item['isCarrier'] === true);
        }

        if(this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER_LIMITED]){
            exportItems = exportItems.filter(item => item['isCarrierLimited'] == true);
        }

        this.items = exportItems
    }

    @Emit()
    closeModal() {}

    mounted() {
        this.filterRowsToInsuranceCarrier()
    }
}
